module.exports = __webpack_public_path__ + "media/images/file-icons/64/007-folder-ce366a549e474b165c1e7d856222fa5c.png";